import { useModal } from '@ebay/nice-modal-react'
import { useNavigate } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import useGeoCheck from '../../hooks/useGeoCheck'
import LoginModal from '../common/log-in-modal'

type LoginSignUpProps = {
  closeProfileDrawer: () => void
}

const LoginSignUp = ({ closeProfileDrawer: closeModal }: LoginSignUpProps) => {
  const { t } = useTranslation('common')
  const logInModal = useModal(LoginModal)
  const navigate = useNavigate()
  const { geoCheck } = useGeoCheck()

  return (
    <div className="v-flx-ctr mb-[50px]">
      <button
        onClick={() => {
          geoCheck(logInModal.show)
          closeModal()
        }}>
        <button
          className="w-[260px] bg-[#00a6ff] uppercase text-base text-center text-white mb-[15px] px-8 py-3 rounded-md"
          onClick={closeModal}>
          {t('login')}
        </button>
      </button>
      <div
        className="flx-ctr text-txt uppercase text-sm whitespace-nowrap relative"
        onClick={() => {
          geoCheck(() => navigate({ to: '/register' }))
          closeModal()
        }}>
        <p className="text-[#00a6ff] underline">{t('register')}</p>
      </div>
    </div>
  )
}

export default LoginSignUp
